import { Popover, Progress, Tag } from 'antd'

export default DistributionIndicator = ({ value }) ->
  [content, children] = (
    if value is 100
      ["Each value set for this attribute is unique, across all nodes with this type."
      , <Tag color="green">Unique</Tag>]
    else if value is 0
      ["There is a single value set for this attribute, across all nodes with this type."
      , <Tag color="red">Common</Tag>]
    else
      ["Across all nodes with this type, the value set for this attribute is unique #{ Math.round(value) }% of the time."
      , <Progress status="normal" percent={value} strokeWidth={2} showInfo={false} />]
  )

  <Popover content={content} placement="right">
    { children }
  </Popover>